import * as types from "./types";
import { get, post } from "@zendesk/knowledge-http-client";
import t from "@zendesk/client-i18n-tools";
import { showError } from "@zendesk/knowledge-redux/lib/actions/NotificationActions";
import { getCurrentBrandId, getCSRFToken } from "@zendesk/knowledge-context";
import {
  getItemAbove,
  getItemBelow,
  isMovingDown,
} from "../../utils/positioning";

function fetchCategoriesRequest() {
  return {
    type: types.FETCH_CATEGORIES_REQUEST,
  };
}

function fetchCategoriesSuccess(categories, page, pageCount, count) {
  return {
    type: types.FETCH_CATEGORIES_SUCCESS,
    categories,
    page,
    pageCount,
    count,
  };
}

function fetchCategoriesFailure(error) {
  return {
    type: types.FETCH_CATEGORIES_FAILURE,
    error: true,
    payload: error,
  };
}

export function fetchCategories({ page }) {
  return (dispatch, getState) => {
    dispatch(fetchCategoriesRequest());

    return get(
      `/hc/api/internal/arrange_articles/categories?multibrand=true&brand_id=${getCurrentBrandId()}&page=${page}&per_page=30`
    )
      .then(({ categories, page, page_count, count }) =>
        dispatch(fetchCategoriesSuccess(categories, page, page_count, count))
      )
      .catch(err => {
        dispatch(fetchCategoriesFailure(err));
      });
  };
}

function positionCategoryRequest(sourceIndex, destinationIndex) {
  return {
    type: types.POSITION_CATEGORY_REQUEST,
    sourceIndex,
    destinationIndex,
  };
}

function positionCategorySuccess(sourceIndex, destinationIndex) {
  return {
    type: types.POSITION_CATEGORY_SUCCESS,
    sourceIndex,
    destinationIndex,
  };
}

function positionCategoryFailure(sourceIndex, destinationIndex, error) {
  return {
    type: types.POSITION_CATEGORY_FAILURE,
    error: true,
    payload: error,
    sourceIndex,
    destinationIndex,
  };
}

export function positionCategory(
  positionedCategoryId,
  sourceIndex,
  destinationIndex
) {
  return (dispatch, getState) => {
    const {
      categories: { list },
    } = getState();

    let payload = {
      positioned_category_id: positionedCategoryId,
    };

    if (isMovingDown(sourceIndex, destinationIndex)) {
      const item = getItemAbove(list, sourceIndex, destinationIndex);
      payload.below_id = item && item.id;
    } else {
      const item = getItemBelow(list, sourceIndex, destinationIndex);
      payload.above_id = item && item.id;
    }

    dispatch(positionCategoryRequest(sourceIndex, destinationIndex));

    return post(
      `/hc/api/internal/arrange_articles/categories/${positionedCategoryId}/position_category?multibrand=true&brand_id=${getCurrentBrandId()}`,
      payload,
      {
        csrfToken: getCSRFToken(),
      }
    )
      .then(() => {
        dispatch(positionCategorySuccess(sourceIndex, destinationIndex));
      })
      .catch(err => {
        dispatch(positionCategoryFailure(sourceIndex, destinationIndex, err));
        dispatch(
          showError(
            t("knowledge-arrange.notification.categoryPositioned.failure")
          )
        );
      });
  };
}

function moveCategoryToTopRequest(sourceIndex) {
  return {
    type: types.MOVE_CATEGORY_TO_TOP_REQUEST,
    sourceIndex,
  };
}

function moveCategoryToTopSuccess() {
  return {
    type: types.MOVE_CATEGORY_TO_TOP_SUCCESS,
  };
}

function moveCategoryToTopFailure(sourceIndex, item, error) {
  return {
    type: types.MOVE_CATEGORY_TO_TOP_FAILURE,
    error: true,
    payload: error,
    sourceIndex,
    item,
  };
}

export function moveCategoryToTop(movedCategory, sourceIndex) {
  return (dispatch, getState) => {
    dispatch(moveCategoryToTopRequest(sourceIndex));

    return post(
      `/hc/api/internal/arrange_articles/categories/${
        movedCategory.id
      }/position_category?multibrand=true&brand_id=${getCurrentBrandId()}`,
      {
        positioned_category_id: movedCategory.id,
        below_id: null,
      },
      {
        csrfToken: getCSRFToken(),
      }
    )
      .then(() => {
        dispatch(moveCategoryToTopSuccess());
      })
      .catch(err => {
        dispatch(moveCategoryToTopFailure(sourceIndex, movedCategory, err));
        dispatch(
          showError(
            t("knowledge-arrange.notification.categoryPositioned.failure")
          )
        );
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/categories/index.js